import React,{useState, useEffect} from 'react';
import { Header} from "./style"
import Hamburguer from './burguer'
import { Link } from "gatsby"
import { FaFacebook } from "react-icons/fa"
import { SiTiktok } from "react-icons/si"
import { RiWhatsappFill } from "react-icons/ri"
import Logo from "../../assets/images/logo.png"
import NavBar from './nav'
const Index = () => {
  const [open, setOpen] = useState(false);
  // para el acordeon
  const [abierto, setAbierto] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Header scrolled={scrolled}>
      <div className="inside container">
        <Link to="/">
          <img src={Logo} alt="logo intramet" />
        </Link>
        <NavBar abierto={abierto} setAbierto={setAbierto} open={open} />
        <div className="header__redes">
          <a target="_blank" rel="noreferrer" href="https://www.facebook.com/Intramet">
            <FaFacebook />
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.tiktok.com/@intramet">
            <SiTiktok />
          </a>
          <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=51945440268&text=Hola INTRAMET: Deseo ponerme en contacto con un representante.">
            <RiWhatsappFill />
          </a>
        </div>
        <Hamburguer open={open} setOpen={setOpen}/>
      </div>
    </Header>
  )
}

export default Index
